module.exports = __webpack_public_path__ + "img/gall-6.0d2d472c.jpg";